import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import PropTypes from 'prop-types'

import routes from '@tabeeb/routes'
import { getIsTenantAuthFlowCompleted, getIsUserAuthorized } from '@tabeeb/modules/account/selectors'
import { getMainBannerColor, getMainTextColor } from '@tabeeb/modules/appConfigState/selectors'

import Navbar from '../components/Navbar'

const NavbarContainer = ({ children, hidden = false }) => {
  const isAuthFlowCompleted = useSelector(getIsTenantAuthFlowCompleted)
  const isAuthorized = useSelector(getIsUserAuthorized)
  const backgroundColor = useSelector(getMainBannerColor)
  const mainTextColor = useSelector(getMainTextColor)
  const location = useSelector((state) => state.router.location.pathname)

  const props = useMemo(
    () => ({
      mainTextColor,
      backgroundColor,
      displayTabs: !location.startsWith(routes.session),
      isAuthorized: isAuthorized && isAuthFlowCompleted,
    }),
    [mainTextColor, backgroundColor, location, isAuthorized, isAuthFlowCompleted]
  )

  return (
    <>
      {!hidden && <Navbar {...props} />}
      {children}
    </>
  )
}

NavbarContainer.propTypes = {
  children: PropTypes.node.isRequired,
  hidden: PropTypes.bool,
}

export default NavbarContainer
